import { urls } from "../api/api.urls";
import makeRequest from "../api/make.request";

export class AiQuestionService {

    static async createAIQuestion(payload: any) {
        return makeRequest(urls.aiQuestion.create, "post", payload);
    }

    static async saveAiQuestion(params: any, payload: any) {
        return makeRequest(urls.aiQuestion.save + params, "post", payload);
    }

    static async getAiSavedQuestions(params: any) {
        return makeRequest(urls.aiQuestion.getSavedQuestions + params, "get")
    }

    static async getAiEnums() {
        return makeRequest(urls.aiQuestion.getEnums, "get");
    }

    static async approveQuestion() {
        return makeRequest(urls.aiQuestion.approve, "post");
    }
}